export const CoreCompetencies = [
    {
        title: "Agentic Workflows",
        subtitle: "Designing autonomous systems",
        icon: "fas fa-robot"
    },
    {
        title: "Probabilistic Logic",
        subtitle: "Non-linear flow automation",
        icon: "fas fa-project-diagram"
    },
    {
        title: "Hybrid Solutions",
        subtitle: "Connecting CRM to AI/Cloud",
        icon: "fas fa-cloud-upload-alt"
    },
    {
        title: "Applied ML & Forecasting",
        subtitle: "Transformers, boosting, time series",
        icon: "fas fa-chart-line"
    },
    {
        title: "Harness Engineering",
        subtitle: "Guardrails, HITL, observability",
        icon: "fas fa-shield-halved"
    },
    {
        title: "Silicon to Cloud",
        subtitle: "FPGA and embedded, by hand",
        icon: "fas fa-microchip"
    }
];
